exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".business-order-view-modal__handling-units[data-v-acd7e8de] {\n  margin-bottom: 0;\n  padding-bottom: 0;\n}\n.flex--spacing-lg .col[data-v-acd7e8de] {\n  margin-right: 10px;\n  margin-left: 10px;\n}\n", ""]);

// exports
